import { rServices } from '@/plugins/api';

import BaseModel from './base';

export default class PollFolders extends BaseModel {
  constructor(folder, url) {
    super(folder, url);

    this.poll_template_count = folder.poll_template_count;
    this.polls_count = folder.polls_count;
    this.type = folder.type;
  }

  async addPolls(poll_ids) {
    const { id } = this;
    const { response, error } = await rServices.polls.pollFolderAdd({ args: [id, { poll_ids }] });
    return { ...response, ...error };
  }

  async removePolls(poll_ids) {
    const { id } = this;
    const { response, error } = await rServices.polls.pollFolderRemove({ args: [id, { poll_ids }] });
    return { ...response, ...error };
  }
}
